// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__9F02d","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2WnI7","obliqueLine":"membershipbadge_obliqueLine__1S70k"};